import '../styles/handee.scss';

import Application from './application';

Application();
